import type { ReactNode } from 'react'

import { styled } from 'styled-components'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'

const ns = 'ParcelRateList'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  /* Breathing room before the order summary / total that follows. */
  margin-bottom: 1.5rem;
`

const Heading = styled.div`
  ${Typography.Subtitle1}
  color: ${Colors.Semantic.Neutral.black};
  margin-bottom: 1rem;
`

type ParcelRateSectionProps = {
  children: ReactNode
}

/**
 * Shared "Shipping Options" section wrapper for the parcel bid flow. Always
 * renders the heading and owns the section's bottom spacing, wrapping whatever
 * is shown beneath — the selectable rate list OR the no-rates blocking banner.
 * Keeping the heading here (rather than inside `ParcelRateList`) means the
 * no-rates state stays contextualized under the same header.
 */
export const ParcelRateSection = ({ children }: ParcelRateSectionProps) => (
  <Container data-testid="parcel-rate-section">
    <Heading>
      <FormattedMessage id={`${ns}.heading`} />
    </Heading>
    {children}
  </Container>
)
